export const START_SCREENSHARE = 'events/START_SCREENSHARE';

/**
 * @return {{type: string}}
 */
export const startScreenShare = () => ({ type: START_SCREENSHARE });
